<mat-dialog-content>
  <div class="bg-white pb-2 pt-2 modal-store">
    <div class="d-flex">
      <h4 class="subtitle">{{ productName }}</h4>
      <div class="text-right">
        <button class="close-button" (click)="closeDialog(true)">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.4099 9L16.7099 2.71C16.8982 2.5217 17.004 2.2663 17.004 2C17.004 1.7337 16.8982 1.47831 16.7099 1.29C16.5216 1.1017 16.2662 0.995911 15.9999 0.995911C15.7336 0.995911 15.4782 1.1017 15.2899 1.29L8.99994 7.59L2.70994 1.29C2.52164 1.1017 2.26624 0.995911 1.99994 0.995911C1.73364 0.995911 1.47824 1.1017 1.28994 1.29C1.10164 1.47831 0.995847 1.7337 0.995847 2C0.995847 2.2663 1.10164 2.5217 1.28994 2.71L7.58994 9L1.28994 15.29C1.19621 15.383 1.12182 15.4936 1.07105 15.6154C1.02028 15.7373 0.994141 15.868 0.994141 16C0.994141 16.132 1.02028 16.2627 1.07105 16.3846C1.12182 16.5064 1.19621 16.617 1.28994 16.71C1.3829 16.8037 1.4935 16.8781 1.61536 16.9289C1.73722 16.9797 1.86793 17.0058 1.99994 17.0058C2.13195 17.0058 2.26266 16.9797 2.38452 16.9289C2.50638 16.8781 2.61698 16.8037 2.70994 16.71L8.99994 10.41L15.2899 16.71C15.3829 16.8037 15.4935 16.8781 15.6154 16.9289C15.7372 16.9797 15.8679 17.0058 15.9999 17.0058C16.132 17.0058 16.2627 16.9797 16.3845 16.9289C16.5064 16.8781 16.617 16.8037 16.7099 16.71C16.8037 16.617 16.8781 16.5064 16.9288 16.3846C16.9796 16.2627 17.0057 16.132 17.0057 16C17.0057 15.868 16.9796 15.7373 16.9288 15.6154C16.8781 15.4936 16.8037 15.383 16.7099 15.29L10.4099 9Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-center p-3">
      <div class="document-type-box">
        <span class="item-document-type" [ngClass]="{ 'item-document-type--active': documentType === 'CPF' }">
          Para você
        </span>
        <span class="item-document-type" [ngClass]="{ 'item-document-type--active': documentType === 'CNPJ' }">
          Para sua empresa
        </span>
      </div>
    </div>

    <form [formGroup]="form">
      <div class="row">
        <div class="col-6">
          <span>
            <div *ngIf="documentType == 'CPF' || selectedProduct?.type === 'CPF'" class="input-container">
              <input
                [ngClass]="cssError('document')"
                class="form-control"
                formControlName="document"
                placeholder="Digite o CPF..."
                type="text"
                [brmasker]="{ person: true }"
                (input)="onDocumentInputChange()"
              />
              <span *ngIf="showSpinner" class="spinner-document">
                <mat-spinner diameter="50"></mat-spinner>
              </span>
              <span *ngIf="showErrorIcon" class="error-icon">
                <img src="../../../../../assets/images/icons/danger-icon.png" alt="Error Icon" />
              </span>
              <span *ngIf="showSuccessIcon" class="success-icon">
                <img src="../../../../../assets/images/icons/tick-circle.png" alt="Success Icon" />
              </span>
            </div>

            <div *ngIf="documentType == 'CNPJ' || selectedProduct?.type === 'CNPJ'" class="input-container">
              <input
                [ngClass]="cssError('document')"
                class="form-control"
                formControlName="document"
                placeholder="Digite o CNPJ..."
                type="text"
                [brmasker]="{ person: true }"
                (input)="onDocumentInputChange()"
              />
              <span *ngIf="showSpinner" class="spinner-document">
                <mat-spinner diameter="50"></mat-spinner>
              </span>
              <span *ngIf="showErrorIcon" class="error-icon">
                <img src="../../../../../assets/images/icons/danger-icon.png" alt="Error Icon" />
              </span>
              <span *ngIf="showSuccessIcon" class="success-icon">
                <img src="../../../../../assets/images/icons/tick-circle.png" alt="Success Icon" />
              </span>
            </div>

            <div *ngIf="hasError('document')" class="invalid-feedback">
              <div *ngIf="hasError('document', 'required|isString')">Campo obrigatório</div>
              <div *ngIf="hasError('document', 'IsCPForCNPJ')">Inválido</div>
            </div>
          </span>
        </div>

        <div class="col-6">
          <div *ngIf="documentType == 'CPF' ">
            <input
              [ngClass]="cssError('name')"
              [class.form-control-disabled]="form.get('name').disabled"
              class="form-control"
              formControlName="name"
              placeholder="Digite o Nome Completo.."
              type="text"
            />
          </div>

          <div *ngIf="documentType == 'CNPJ'">
            <input
              [ngClass]="cssError('name')"
              [class.form-control-disabled]="form.get('name').disabled"
              class="form-control"
              formControlName="name"
              placeholder="Digite a Razão Social.."
              type="text"
            />
          </div>

          <div *ngIf="hasError('name')" class="invalid-feedback">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>

      <div *ngIf="hasError('document')" class="invalid-feedback invalid-feedback-2">
        <span *ngIf="hasError('document', 'errorGetDocument')">{{ newProposalPermissionMessage }}</span>
      </div>

      <div class="row">
        <div class="col-4">
          <input
            [ngClass]="cssError('date_of_birth')"
            [class.form-control-disabled]="form.get('date_of_birth').disabled"
            class="form-control"
            formControlName="date_of_birth"
            placeholder="Data de Nascimento"
            type="text"
            required
            id="birthdate"
            name="birthdate"
            mask="00/00/0000"
          />
          <div *ngIf="hasError('date_of_birth')" class="invalid-feedback" style="display: block">
            <div *ngIf="hasError('date_of_birth', 'required')">Campo obrigatório</div>
            <div *ngIf="hasError('date_of_birth', 'invalidDate')">A data de nascimento inválida</div>
            <div *ngIf="hasError('date_of_birth', 'invalidProducts')">
              Idade não permitida para a contratação do produto
            </div>
          </div>
        </div>

        <div class="col-4">
          <input
            [ngClass]="cssError('email')"
            [class.form-control-disabled]="form.get('email').disabled"
            class="form-control"
            formControlName="email"
            placeholder="Digite o Email..."
            type="text"
          />
          <div *ngIf="hasError('email')" class="invalid-feedback">
            <div *ngIf="hasError('email', 'required')">Campo obrigatório</div>
            <div *ngIf="hasError('email', 'IsCPForCNPJ')">Inválido</div>
            <div *ngIf="hasError('email', 'NotExists')">Já cadastrado em outro cliente</div>
            <div *ngIf="hasError('email', 'email')">Email inválido</div>
          </div>
        </div>

        <div class="col-4">
          <input
            [ngClass]="cssError('phone')"
            [class.form-control-disabled]="form.get('phone').disabled"
            class="form-control"
            formControlName="phone"
            placeholder="Digite o Celular.."
            type="text"
            [textMask]="{ mask: this.phoneMask }"
          />
          <div *ngIf="hasError('phone')" class="invalid-feedback">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>

      <div class="col-12 p-0">
        <div class="row" formGroupName="address">
          <div class="col-6">
            <input
              (ngModelChange)="getCep()"
              [brmasker]="{ mask: '00000-000', type: 'num' }"
              [ngClass]="cssError('address.zipcode')"
              [class.form-control-disabled]="form.get('address.zipcode').disabled"
              class="form-control"
              formControlName="zipcode"
              maxlength="9"
              placeholder="Digite o CEP"
              type="text"
            />
            <div *ngIf="hasError('address.zipcode')" class="invalid-feedback">
              <div *ngIf="hasError('address.zipcode', 'required')">Campo obrigatório</div>
              <div *ngIf="hasError('address.zipcode', 'minLength')">O CEP precisa ter 8 dígitos</div>
            </div>
          </div>

          <div class="col-6">
            <input
              [ngClass]="cssError('address.street')"
              [class.form-control-disabled]="form.get('address.street').disabled"
              class="form-control"
              formControlName="street"
              placeholder="Digite o logradouro..."
              type="text"
            />
            <div *ngIf="hasError('address.street')" class="invalid-feedback">
              <div>Campo obrigatório</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 p-0" formGroupName="address">
        <div class="row">
          <div class="col-6">
            <input
              [ngClass]="cssError('address.neighborhood')"
              [class.form-control-disabled]="form.get('address.neighborhood').disabled"
              class="form-control"
              formControlName="neighborhood"
              placeholder="Digite o bairro..."
              type="text"
            />
            <div *ngIf="hasError('address.neighborhood')" class="invalid-feedback">
              <div>Campo obrigatório</div>
            </div>
          </div>

          <div class="col-6">
            <input
              [class.form-control-disabled]="form.get('address.complement').disabled"
              class="form-control"
              formControlName="complement"
              placeholder="Digite o complemento"
              type="text"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <input
              [ngClass]="cssError('address.number')"
              [class.form-control-disabled]="form.get('address.number').disabled"
              class="form-control"
              formControlName="number"
              placeholder="Digite o número..."
              type="text"
            />
            <div *ngIf="hasError('address.number')" class="invalid-feedback">
              <div>Campo obrigatório</div>
            </div>
          </div>

          <div class="col-4">
            <input
              [ngClass]="cssError('address.city')"
              [class.form-control-disabled]="form.get('address.city').disabled"
              class="form-control"
              formControlName="city"
              placeholder="Digite a Cidade..."
              type="text"
            />
            <div *ngIf="hasError('address.city')" class="invalid-feedback">
              <div>Campo obrigatório</div>
            </div>
          </div>

          <div class="col-4">
            <select
              class="form-control"
              [ngClass]="cssError('address.state')"
              [class.form-control-disabled]="form.get('address.state').disabled"
              formControlName="state"
              type="text"
            >
              <option value="" disabled selected>Digite sua UF...</option>
              <option *ngFor="let item of states" [value]="item.id">{{ item.name }}</option>
            </select>
            <div *ngIf="hasError('address.state')" class="invalid-feedback">
              <div>Campo obrigatório</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="documentType == 'CNPJ'">
        <div class="col-12">
          <input
            class="form-control"
            [class.form-control-disabled]="form.get('responsible').disabled"
            formControlName="responsible"
            [ngClass]="cssError('responsible')"
            placeholder="Digite o Responsável..."
          />
          <div *ngIf="hasError('responsible')" class="invalid-feedback">Campo obrigatório</div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <input
            class="form-control"
            formControlName="value"
            [ngClass]="cssError('value')"
            [class.form-control-disabled]="form.get('value').disabled"
            placeholder="Digite o Valor..."
            type="text"
            [options]="optionsMoney"
            currencyMask
          />
          <div *ngIf="hasError('value')" class="invalid-feedback">Campo obrigatório</div>
        </div>

        <div class="col-6">
          <select
            class="form-control"
            [ngClass]="cssError('isCheckingAccount')"
            [class.form-control-disabled]="form.get('isCheckingAccount').disabled"
            formControlName="isCheckingAccount"
            type="text"
            placeholder="Correntista"
          >
            <option value="true">Correntista</option>
            <option value="false">Não-correntista</option>
          </select>
          <div *ngIf="hasError('isCheckingAccount')" class="invalid-feedback">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>

      <div class="flex pb-4" *ngIf="form.value.isCheckingAccount === 'true'" formGroupName="checkingAccountInfo">
        <div>
          <input
            class="form-control"
            [ngClass]="cssError('checkingAccountInfo.agency')"
            formControlName="agency"
            placeholder="0000"
            mask="0000"
            type="text"
          />
          <div *ngIf="hasError('checkingAccountInfo.agency')" class="invalid-feedback">
            <div>Campo obrigatório</div>
          </div>
        </div>
        <div class="col-4">
          <input
            [ngClass]="cssError('checkingAccountInfo.account')"
            class="form-control"
            mask="00000-0"
            formControlName="account"
            placeholder="00000-0"
            type="text"
          />
          <div *ngIf="hasError('checkingAccountInfo.account')" class="invalid-feedback">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>
      <div class="modules mt-2">
        <div class="check-modules">
          <div class="models check-fields condition">
            <input name="1" type="checkbox" [checked]="terms" (click)="checkTerms()" />
            <p class="col-11">
              Declaro que li e concordo com a política de privacidade de dados e com o termo de autorização de scr e
              consentimento de dados do Banco Central do Brasil, para receber a melhor proposta possível.
            </p>
          </div>
        </div>
      </div>
    </form>

    <div class="d-flex justify-content-center w-100 mt-3">
      <button class="btn-cancel" (click)="closeDialog(true)">Cancelar</button>
      <button class="btn-send" (click)="send()" [disabled]="!form.valid">Solicitar Agora</button>
    </div>
  </div>
</mat-dialog-content>
